import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';


// Create Document Component
const MyDocument = ({ pdfContent, anexos, fechaIni, fechaFin }) => {
    

    function PdfPage(datos) {
       
         
        
      }
    return (
        <Document>

            <Page size="A4" style={styles.page}>
                <View style={{ display: 'flex', marginTop: 30, flex: 1.5, maxHeight: 'auto' }}>
                    <Text>Fecha Inicio:{fechaIni}</Text>
                    <Text>Fecha Final: {fechaFin}</Text>
                </View>

{/*                 <View style={{ display: 'flex', marginTop: 30, flex: 1.5, maxHeight: 'auto' }}>
                    <Text>Anexos filtrados:</Text><Text style={{ justifyContent:'center' }}> {anexos}</Text>
                </View> */}

                <View style={{ width: '100%' , maxHeight: 70, flexDirection: 'row', display: 'flex', }}>
                    <View style={{ display: 'flex', flex: 1. }}>
                        <Text>Anexo:</Text>
                    </View>
                    <View style={{ display: 'flex', flex: 1}}>
                        <Text>DNID</Text>
                    </View>
                    <View style={{ display: 'flex', flex: 1 }}>
                        <Text>Duración</Text>
                    </View>
                    <View style={{ display: 'flex', flex: 1 }}>
                        <Text>Valor</Text>
                    </View>
                </View>
                <PdfPage datos={pdfContent}></PdfPage>
                
            </Page>
        </Document>
    )
}

// Create styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#E4E4E4',
        display: 'flex',
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },

    label: {
        fontSize: 13,
        marginTop: 10
    }
});

export default MyDocument;